// extracted by mini-css-extract-plugin
export var dataCell = "_ph-2";
export var dataRow = "_ph-0";
export var headerRow = "_ph-1";